import type { ReactNode } from "react";

/**
 * Redactioneel tekstblok voor overzichtspagina's. Bedoeld voor lopende tekst
 * met organische interne links naar de relevante vervolgpagina's.
 */
export function ProseSection({
  id,
  title,
  children,
}: {
  id: string;
  title: string;
  children: ReactNode;
}) {
  return (
    <section aria-labelledby={id} className="mx-auto max-w-7xl px-4 py-14 sm:px-6">
      <div className="max-w-3xl">
        <h2 id={id} className="text-2xl font-bold tracking-tight text-foreground">
          {title}
        </h2>
        <div className="mt-4 space-y-4 text-[15px] leading-7 text-muted-foreground [&_a]:font-medium [&_a]:text-primary [&_a]:underline [&_a]:decoration-primary/40 [&_a]:underline-offset-4 hover:[&_a]:decoration-primary">
          {children}
        </div>
      </div>
    </section>
  );
}
